module.exports = __webpack_public_path__ + "static/musee_olympique_livre3D2-480554f6a0c19ce5b37dcc5906ba73bf.png";